document.addEventListener('DOMContentLoaded', () => {
  const modal = document.getElementById('QuickViewModal');


  if (!modal) return;

  const closeBtn = document.getElementById('QuickViewClose');
  const imgEl = document.getElementById('QuickViewImage');
  const titleEl = document.getElementById('QuickViewTitle');
  const skuEl = document.getElementById('QuickViewSku');
  const vendorEl = document.getElementById('QuickViewVendor');
  const priceEl = document.getElementById('QuickViewPrice');
  const descEl = document.getElementById('QuickViewDescription');
  const qtyEl = document.getElementById('QuickViewQuantity');
  const buyBtn = document.getElementById('QuickViewBuyNow');
  const tagsEl = document.getElementById('QuickViewTags');
  const compareAtEl = document.getElementById('QuickViewCompareAt');
  const saleTagEl = document.getElementById('QuickViewSaleTag');
  const outOfStockEl = document.getElementById('QuickViewOutOfStockMessage');
  const waitlistEl = document.getElementById('QuickViewWaitlist');
  const waitlistForm = document.getElementById('QuickViewWaitlistForm');
  const variantOptionsEl = document.getElementById('QuickViewVariantOptions');
  const variantButtonsEl = document.getElementById('QuickViewVariantButtons');
  const customAmountWrap = document.getElementById('QuickViewCustomAmount');
  const customAmountInput = document.getElementById('QuickViewCustomAmountInput');
  const qtyErrorEl = document.getElementById('QuickViewQtyError');
  const wishlistBtn = document.getElementById('QuickViewWishlist');

  document.body.addEventListener('click', async (e) => {
    if (!(e.target instanceof Element)) return;

    const btn = e.target.closest('[data-action="quick-view"]');
    if (!btn) return;

    const handle = btn.getAttribute('data-product-handle');
    if (!handle) return;
    const cardInventoryQty = parseInt(btn.dataset.inventoryQuantity, 10);

    try {
      const imgWrapper = imgEl?.closest?.('[data-image-wrapper]');
      if (imgWrapper) {
        delete imgWrapper.dataset.loaded;
      }

      // --- Fetch product JSON ---
      const res = await fetch(`/products/${handle}.js`);
      if (!res.ok) throw new Error('Failed to fetch product');
      const product = await res.json();

      //console.log('Fetched product:', product.title, product.tags);

      const formatMoney = (value) => {
        if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
          return window.Shopify.formatMoney(value, window.Shopify.money_format || '${{amount}}');
        }
        return `$${(value / 100).toFixed(2)}`;
      };

      const isGiftCardProduct = Array.isArray(product.tags)
        ? product.tags.includes('Digital Gift Card') || product.handle === 'physical-gift-card'
        : product.handle === 'physical-gift-card';

      let selectedVariant = null;

      const formatUsd = (value) => {
        const num = Number(value);
        if (!Number.isFinite(num)) return 'US$0.00';
        return `US$${num.toFixed(2)}`;
      };

      const applyVariant = (variant) => {
        selectedVariant = variant;
        skuEl.textContent = variant?.sku ? `SKU: ${variant.sku}` : '';
        priceEl.textContent = variant ? formatMoney(variant.price) : '';

        if (compareAtEl) {
          const compareAt = variant?.compare_at_price;
          if (compareAt && compareAt > variant?.price) {
            priceEl.classList.add('text-red-600');
            compareAtEl.textContent = `(${formatMoney(compareAt)})`;
            compareAtEl.classList.remove('hidden');
            if (saleTagEl) saleTagEl.classList.remove('hidden');
          } else {
            priceEl.classList.remove('text-red-600');
            compareAtEl.textContent = '';
            compareAtEl.classList.add('hidden');
            if (saleTagEl) saleTagEl.classList.add('hidden');
          }
        }

        const hasVariant = !!variant;
        const isOutOfStock = hasVariant && (window.BlueRoseStockState?.isOutOfStock(variant) ?? false);
        if (outOfStockEl) outOfStockEl.classList.toggle('hidden', !isOutOfStock);
        if (waitlistEl) waitlistEl.classList.toggle('hidden', !isOutOfStock);
        if (buyBtn) buyBtn.classList.toggle('hidden', isOutOfStock);
        if (qtyEl) {
          qtyEl.disabled = !hasVariant || isOutOfStock;
          const maxQty = (variant?.inventory_quantity != null ? variant.inventory_quantity : null) ?? (Number.isFinite(cardInventoryQty) ? cardInventoryQty : null);
          if (maxQty != null && maxQty > 0) {
            qtyEl.max = maxQty;
            if (parseInt(qtyEl.value, 10) > maxQty) qtyEl.value = maxQty;
          } else {
            qtyEl.removeAttribute('max');
          }
          qtyEl.classList.toggle('bg-gray-100', !hasVariant || isOutOfStock);
          qtyEl.classList.toggle('cursor-not-allowed', !hasVariant || isOutOfStock);
        }

        const isCustom = variant?.title?.toLowerCase() === 'custom';
        if (customAmountWrap && customAmountInput) {
          customAmountWrap.classList.toggle('hidden', !isCustom);
          if (isCustom) {
            if (customAmountInput.dataset.userEdited !== 'true') {
              customAmountInput.value = '';
            }
            customAmountInput.focus();
            if (!customAmountInput.value) {
              priceEl.textContent = 'US$0.00';
            }
          } else {
            customAmountInput.dataset.userEdited = '';
          }
        }

        if (buyBtn) {
          if (!variant) {
            buyBtn.disabled = true;
            buyBtn.textContent = 'Select Amount';
            buyBtn.classList.add('bg-[#9bb0cf]', 'cursor-not-allowed', 'hover:bg-[#1f4577]');
            buyBtn.classList.remove('hover:bg-[#1f4577]');
          } else if (isCustom && customAmountInput && Number(customAmountInput.value) <= 0) {
            buyBtn.disabled = true;
            buyBtn.textContent = 'Enter Amount';
            buyBtn.classList.add('bg-[#9bb0cf]', 'cursor-not-allowed', 'hover:bg-[#1f4577]');
            buyBtn.classList.remove('hover:bg-[#1f4577]');
          } else if (isOutOfStock) {
            buyBtn.disabled = true;
            buyBtn.classList.add('bg-[#9bb0cf]', 'cursor-not-allowed', 'hover:bg-[#1f4577]');
            buyBtn.classList.remove('hover:bg-[#1f4577]');
          } else {
            buyBtn.disabled = false;
            buyBtn.textContent = 'Add to Cart';
            buyBtn.classList.remove('bg-[#9bb0cf]', 'cursor-not-allowed', 'hover:bg-[#1f4577]');
            buyBtn.classList.add('hover:bg-[#1f4577]', 'cursor-pointer');
          }
        }
      };

      // --- Populate product info ---
      const variant =
        Array.isArray(product.variants) && product.variants.length
          ? product.variants.find(v => v.available) || product.variants[0]
          : null;

      imgEl.src = product.images[0] || '';
      imgEl.alt = product.title;
      if (wishlistBtn) {
        wishlistBtn.dataset.wishlistProductId = String(product.id || '');
        wishlistBtn.classList.toggle('hidden', !product.id);
      }
      vendorEl.textContent = product.vendor || '';
      titleEl.textContent = product.title;
      skuEl.textContent = variant?.sku ? `SKU: ${variant.sku}` : '';
      priceEl.textContent = variant ? formatMoney(variant.price) : formatMoney(product.price);
      if (waitlistForm) {
        window.BlueRoseStockState?.updateWaitlistForm(waitlistForm, {
          productHandle: product.handle || '',
          productTitle: product.title || '',
          productUrl: product.handle ? `/products/${product.handle}` : '',
          productImage: Array.isArray(product.images) && product.images.length ? product.images[0] : '',
          variant,
        });
      }
      if (variantOptionsEl && variantButtonsEl) {
        variantButtonsEl.innerHTML = '';
        if (isGiftCardProduct && Array.isArray(product.variants) && product.variants.length > 0) {
          variantOptionsEl.classList.remove('hidden');
          product.variants.forEach((v) => {
            const optionBtn = document.createElement('button');
            optionBtn.type = 'button';
            optionBtn.dataset.variantId = String(v.id);
            optionBtn.className =
              'border-1 border-gray-900 px-4 py-3 text-sm font-semibold text-gray-900 hover:border-[#00538D] hover:bg-gray-100 hover:text-[#00538D] transition';
            const isCustomVariant = v.title?.toLowerCase() === 'custom';
            if (isCustomVariant) {
              return;
            }
            optionBtn.textContent = formatMoney(v.price).replace('$', 'US$');
            if (v.available === false) {
              optionBtn.disabled = true;
              optionBtn.classList.add('opacity-50', 'cursor-not-allowed');
            }
            optionBtn.addEventListener('click', () => {
              variantButtonsEl.querySelectorAll('button').forEach((b) => {
                b.classList.remove('border-[#5b3df4]', 'text-[#5b3df4]');
              });
              optionBtn.classList.add('border-[#5b3df4]', 'text-[#5b3df4]');
              applyVariant(v);
            });
            variantButtonsEl.appendChild(optionBtn);
          });
          applyVariant(null);
        } else {
          variantOptionsEl.classList.add('hidden');
          applyVariant(variant);
        }
      } else {
        applyVariant(variant);
      }

      if (customAmountWrap) customAmountWrap.classList.add('hidden');

      // --- Qty validation ---
      if (qtyErrorEl) qtyErrorEl.classList.add('hidden');
      qtyEl.oninput = () => {
        const val = parseInt(qtyEl.value, 10);
        const max = parseInt(qtyEl.max, 10);
        if (qtyErrorEl && max > 0 && val > max) {
          qtyErrorEl.textContent = `Only ${max} available — please enter ${max} or less.`;
          qtyErrorEl.classList.remove('hidden');
          if (buyBtn) buyBtn.disabled = true;
        } else {
          if (qtyErrorEl) qtyErrorEl.classList.add('hidden');
          if (buyBtn && selectedVariant) buyBtn.disabled = false;
        }
      };

      // --- Description (sanitize) ---
      const decodedDesc = product.description
        .replace(/\\u003c/g, '<')
        .replace(/\\u003e/g, '>')
        .replace(/\\u0026/g, '&')
        .replace(/<script.*?>.*?<\/script>/gi, '');
      descEl.innerHTML = decodedDesc;
      qtyEl.value = 1;

      // --- 🏷️ Render product tags ---
      tagsEl.innerHTML = ''; // clear previous tags
      if (Array.isArray(product.tags) && product.tags.length > 0) {
        const highlightTags = ['Sale', 'Best Seller', 'Clearance', 'New', 'Limited'];
        const tagStyles = {
          'Sale': 'bg-red-100 text-red-700 border-red-200',
          'Best Seller': 'bg-yellow-100 text-yellow-700 border-yellow-200',
          'Clearance': 'bg-orange-100 text-orange-700 border-orange-200',
          'New': 'bg-green-100 text-green-700 border-green-200',
          'Limited': 'bg-blue-100 text-blue-700 border-blue-200'
        };

        product.tags.forEach(tag => {
          if (highlightTags.includes(tag)) {
            const badge = document.createElement('span');
            const style = tagStyles[tag] || 'bg-[#00538d]/10 text-[#00538d] border-[#00538d]/20';
            badge.textContent = tag;
            badge.className = `inline-block rounded-full px-2 py-1 text-xs font-medium uppercase tracking-wide border ${style}`;
            tagsEl.appendChild(badge);
          }
        });
      }

      if (window.BlueRoseWishlist?.syncWishlistButtons) {
        window.BlueRoseWishlist.syncWishlistButtons(modal);
      }

      // --- Add to Cart action ---
      buyBtn.onclick = () => {
        const qty = parseInt(qtyEl.value, 10) || 1;
        if (!selectedVariant) return;

        const max = parseInt(qtyEl.max, 10);
        if (max > 0 && qty > max) {
          if (qtyErrorEl) {
            qtyErrorEl.textContent = `Only ${max} in stock — please enter ${max} or less.`;
            qtyErrorEl.classList.remove('hidden');
          }
          return;
        }
        if (qtyErrorEl) qtyErrorEl.classList.add('hidden');

        const isCustom = selectedVariant?.title?.toLowerCase() === 'custom';
        const properties = {};
        if (isCustom && customAmountInput) {
          const customValue = customAmountInput.value.trim();
          if (customValue) properties['Custom amount'] = customValue;
        }
        addToCartAndRedirect(selectedVariant.id, qty, properties);
      };

      // --- Open modal ---
      modal.classList.remove('hidden');
      requestAnimationFrame(() => {
        modal.querySelector('div > .transform')?.classList.add('scale-100');
      });
      document.body.classList.add('overflow-hidden');
    } catch (err) {
      console.error('Quick View error:', err);
    }
  });

  window.BlueRoseStockState?.bindWaitlistForms(document);

  // --- Close modal ---
  closeBtn.addEventListener('click', closeModal);
  modal.addEventListener('click', (e) => {
    if (e.target === modal) closeModal();
  });

  function closeModal() {
    document.body.classList.remove('overflow-hidden');
    modal.classList.add('hidden');
  }

  // --- Add to cart → open cart overlay ---
  async function addToCartAndRedirect(variantId, qty, properties = {}) {
    try {
      buyBtn.disabled = true;
      buyBtn.textContent = 'Adding…';

      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        credentials: 'same-origin',
        body: JSON.stringify({ id: variantId, quantity: qty, properties }),
      });
      const added = await res.json();
      if (added.status) throw new Error(added.message || 'Could not add item');

      if (window.oaiq) oaiq('measure', 'custom', { type: 'custom' }, { custom_event_name: 'add-to-cart' });
      // Algolia: credit the add to the search it came from (snippets/algolia-insights.liquid)
      try { if (window.BlueRoseInsights) window.BlueRoseInsights.addedToCart(added); } catch (e) {}

      const cart = await fetch('/cart.js').then(r => r.json());
      const overlay = document.querySelector('[data-cart-overlay]');
      if (overlay) overlay.dataset.source = 'quick-view';
      if (typeof window.refreshCartOverlay === 'function') window.refreshCartOverlay(cart);
      closeModal();
      // On a phone there is no overlay: confirm with the added bar and keep
      // the shopper's place in the collection.
      if (window.innerWidth < 768 && typeof window.brpShowAddedBar === 'function') {
        window.__brpLastAdd = null;
        window.brpShowAddedBar(cart);
        return;
      }
      window.scrollTo({ top: 0, behavior: 'smooth' });
      setTimeout(() => {
        if (typeof window.openCartOverlay === 'function') {
          window.openCartOverlay();
        } else {
          const cartTrigger = document.getElementById('cart-quickview');
          if (cartTrigger) cartTrigger.click();
        }
      }, 400);
    } catch (err) {
      console.error('Add to cart error:', err);
      buyBtn.disabled = false;
      buyBtn.textContent = 'Add to Cart';
    }
  }

  // refreshCartOverlay is defined once, globally, in snippets/cart-quickview.liquid
  // (loaded on every page via the header) — see that file for why a per-file
  // copy here was a bug (it only ever knew how to rebuild the A/B test's variant A).
});
